module.exports = __webpack_public_path__ + "img/arrow_top.ea54f36c.svg";